import { BASE_URL } from "../environment";
import makeRequest from "../makeRequest";

export default async function postVodafoneOrder(body) {
  try {
    const results = await makeRequest(`${BASE_URL}/vodafoneorder`, {
      method: "POST",
      body,
    });

    const { VodafoneReference, CustomerReference, Status, ErrorMessage } = results || {};

    if (ErrorMessage) throw ErrorMessage;

    if (VodafoneReference || (Status === "Pending" && CustomerReference)) {
      return { reference: VodafoneReference || CustomerReference, status: Status };
    }

    if (typeof results === "string") {
      throw "An unexpected error occurred. Please contact support.";
    }

    throw "An unknown error occurred placing the Vodafone order. The order has not been placed.";
  } catch (err) {
    if (err && typeof err === "string") throw err;
    throw "An unexpected error occurred. Please contact support.";
  }
}
